import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Step {
  id: string;
  icon: string;
  title: string;
  description: string;
  detail: string;
}

const steps: Step[] = [
{
  id: 'step_1',
  icon: 'PhoneIcon',
  title: 'Virtuelle Nummer in 2 Minuten',
  description: 'Registrieren Sie sich und erhalten Sie sofort eine dedizierte virtuelle Telefonnummer.',
  detail: 'Keine SIM-Karte, keine Hardware – alles in der Cloud.'
},
{
  id: 'step_2',
  icon: 'ArrowPathIcon',
  title: 'SMS automatisch weitergeleitet',
  description: 'Alle 2FA-SMS werden automatisch an Ihr Dashboard übermittelt.',
  detail: 'In Echtzeit, verschlüsselt, zuverlässig.'
},
{
  id: 'step_3',
  icon: 'ComputerDesktopIcon',
  title: 'Codes in Dashboard anzeigen',
  description: 'Greifen Sie von jedem Gerät auf Ihre SMS-Codes zu – sicher und jederzeit.',
  detail: 'Desktop, Tablet, Smartphone – überall verfügbar.'
}];


export default function HowItWorksSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <div className="flex justify-center mb-4">
            <div className="bg-blue-100 p-3 rounded-full">
              <Icon name="CogIcon" size={24} variant="outline" className="text-primary" />
            </div>
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-foreground tracking-tight mb-4">
            So funktioniert es
          </h2>
          <p className="text-muted-foreground font-light">
            In nur 3 einfachen Schritten zu Ihrem sicheren 2FA-Dashboard
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          {steps.map((step, index) =>
          <div
            key={step.id}
            className={`flex flex-col items-center text-center p-6 rounded-3xl hover:bg-slate-50 transition-colors duration-300 reveal delay-${(index + 1) * 100}`}>
            
              {/* Step Number */}
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary font-semibold text-lg mb-4">
                {index + 1}
              </div>
              
              {/* Icon */}
              <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center text-primary mb-6">
                <Icon name={step.icon as any} size={28} variant="outline" className="text-primary" />
              </div>
              
              {/* Content */}
              <h3 className="font-medium text-lg text-foreground mb-3">
                {step.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-sm mb-2">
                {step.description}
              </p>
              <p className="text-xs text-primary font-medium">
                {step.detail}
              </p>
            </div>
          )}
        </div>

        {/* Dashboard Preview */}
        <div className="reveal delay-400">
          <div className="relative rounded-2xl overflow-hidden shadow-xl shadow-slate-900/5 border border-slate-200">
            <AppImage
              src="https://img.rocket.new/generatedImages/rocket_gen_img_1c3f7059b-1768811663595.png"
              alt="Dashboard showing incoming SMS codes in real-time with timestamps and secure access controls"
              className="w-full h-[400px] object-cover" />
            
            {/* Overlay badge */}
            <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
              <span className="text-sm font-medium text-foreground">SMS empfangen in 3 Sekunden</span>
            </div>
          </div>
        </div>
      </div>
    </section>);

}